import { render, staticRenderFns } from "./RcWidgetLiveResultsHouse.vue?vue&type=template&id=5eeee48a&"
import script from "./RcWidgetLiveResultsHouse.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports